module.exports = __webpack_public_path__ + "static/img/baby.f8cde5a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VX/mintWalks/baby.gif
// module id = Mv7x
// module chunks = 1